import { __assign, __awaiter, __decorate, __generator, __metadata } from "tslib";
import { action } from 'mobx';
import { Collection } from 'mobx-cobweb';
import { inject } from '@ekuaibao/react-ioc';
var PermissionPopVM = (function () {
    function PermissionPopVM() {
        var _this = this;
        this.savePermission = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.collection.request("/api/v1/group/center/share/permission/addAll", {
                            skipCache: true,
                            method: 'PUT',
                            data: __assign({}, data),
                        })];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
    }
    var _a;
    __decorate([
        inject('collection'),
        __metadata("design:type", typeof (_a = typeof Collection !== "undefined" && Collection) === "function" ? _a : Object)
    ], PermissionPopVM.prototype, "collection", void 0);
    __decorate([
        action,
        __metadata("design:type", Object)
    ], PermissionPopVM.prototype, "savePermission", void 0);
    return PermissionPopVM;
}());
export { PermissionPopVM };
